import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    namePrefix: Yup.string(),
});
